/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_XY_LIVE", "566")
  

// 接口文档



export interface API77118Req {
  
  /** sessionCode */
  sessionCode: string;
  /** sessionName */
  sessionName: string;
};



export type API77118Res = {};


// 接口函数 77118 修改会话

export interface IUsePostAPI77118Return {
  /** 修改会话: 接口请求状态 */
  isAPI77118Loading: boolean;
  /** 修改会话: 接口请求返回数据 */
  dataAPI77118: API77118Res;
  /**  修改会话: 接口数据请求方法 */
  fetchAPI77118Data: (inputs: API77118Req, config?: YWRequestConfig) => Promise<API77118Res>;
  /** 修改会话: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI77118 = ():IUsePostAPI77118Return => {
  let isMount = true;
  const [isAPI77118Loading, setIsAPI77118Loading] = useState(false);
  const [dataAPI77118, setDataAPI77118] = useState<API77118Res>({} as API77118Res);
  const requestUrl = `${basePath}/yoaichat-admin/chat/modify/session`;

  const fetchAPI77118Data = async (inputs: API77118Req, config?: YWRequestConfig): Promise<API77118Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API77118Req>) || {}) as API77118Req;
    
  
    if ( isMount ) {
      setIsAPI77118Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API77118Res>(`${basePath}/yoaichat-admin/chat/modify/session`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI77118(res || {} as API77118Res);
        setIsAPI77118Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI77118Loading(false);
      }
      return false as unknown as API77118Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI77118Loading,
    dataAPI77118,
    fetchAPI77118Data,
    requestUrl,
  }
}

